import { render, staticRenderFns } from "./editProfilePicture.vue?vue&type=template&id=81aeeb06&scoped=true"
import script from "./editProfilePicture.vue?vue&type=script&lang=js"
export * from "./editProfilePicture.vue?vue&type=script&lang=js"
import style0 from "./editProfilePicture.vue?vue&type=style&index=0&id=81aeeb06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aeeb06",
  null
  
)

export default component.exports